










































































import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import { InputValidation } from '../../../helpers/inputValidation';
import { Environment } from '../../../helpers/Environment';
import FormatParameterService from '../../../services/FormatParameterService';
import { IFormatParameter, FormatParameter } from '@models';
import { PropType } from 'vue';
import { BuiltInParametersHelper } from '../FormatParametersEditor/BuiltInParametersHelper';


@Component
export default class FormatParametersEditor extends Vue {
  name = 'format-parameters-editor';

  inputValidation = InputValidation;
  environment: Environment = new Environment();
  formatParametersService = FormatParameterService;

  @Prop({
    type: Array as PropType<IFormatParameter[]>,
    default: () => []
  })
  values: IFormatParameter[];

  @Watch("parameters")
  updateAssetsPath() {
    this.environment.GetEnvironmentVariables(["Environment:AssetPath"]).then(
      response => {
        this.assetsPath = response["Environment:AssetPath"];
      }
    )
  }
  assetsPath: string = "";

  foundTags: string[] = [];
  parameters: Array<IFormatParameter> = new Array<FormatParameter>();

  @Prop(String) sourcetext: string;
  @Prop({ type: String, default: "" }) formatversionid: string;
  @Prop({ type: Boolean, default: true }) showhint: boolean;

  @Watch("parameters", { deep: true })
  updateValue() {
    this.$emit('input', this.parameters);
  }

  @Watch("sourcetext")
  findTags() {
    this.foundTags = [];
    if (this.sourcetext) {
      const regexp = /{{(\w+)}}/g;
      const result = this.sourcetext.match(regexp);

      if (result) {
        var results = Array.from(result);
        results.forEach(tag => {
          if (BuiltInParametersHelper.BuiltInParameters.indexOf(tag) == -1) {
            this.foundTags.push(tag);
          }
        });
      }
    }
  }

  addParameterShorthand(ev: Event, parameterTag: string) {
    if (parameterTag) {
      var parameter = new FormatParameter();
      parameter.tag = parameterTag;
      this.addParameter(ev, parameter);
    }
  }

  async addParameter(ev: Event, parameter: IFormatParameter = null) {
    if (!parameter) {
      parameter = new FormatParameter();
    }

    this.parameters = [...this.parameters, parameter];
  }

  removeParameter(parameter: IFormatParameter) {
    this.parameters = this.parameters.filter(x => x.tag !== parameter.tag);
  }

  formatParameterTypeChanged(parameter: IFormatParameter) {
    parameter.value = null;
    parameter.file = null;
  }

  async created() {
    this.parameters = this.values;
    this.findTags();
  }

}
